import { createContext } from "react";

export const PSContext = createContext({});

export const SHLContext = createContext([]);
